import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";
import ResourceException from "../services/ResourceException";

export function changeQuery(query) {
    return {type: types.CHANGE_MULTISTEP_SELECT_QUERY, query};
}

export function focus(inputId) {
    return {type: types.FOCUS_MULTISTEP_SELECT_INPUT, inputId};
}

export function add(itemId) {
    return {type: types.ADD_MULTISTEP_ITEM, itemId};
}

export function remove(itemId) {
    return {type: types.DELETE_MULTISTEP_ITEM, itemId};
}

export function select(itemId) {
    return {type: types.SELECT_MULTISTEP_ITEM, itemId};
}

export function deselect() {
    return {type: types.DESELECT_MULTISTEP_ITEM};
}

export function getSupplierCompetenciesSuccess(competencies) {
    return {type: types.GET_SUPPLIER_COMPETENCIES_SUCCESS, competencies};
}

export function getSelectedCompetenciesSuccess(competencies) {
    return {type: types.GET_SELECTED_COMPETENCIES_SUCCESS, competencies};
}

export function getSupplierCompetenciesError() {
    return {
        type: types.SHOW_MESSAGE,
        message: 'Could not get the list of competencies.',
        messageType: 'error'
    };
}

export function getSupplierCompetencies() {
    return (dispatch) => {

        return PrivateAPIResource.all('supplier-competencies').then(competencies => {
            dispatch(getSupplierCompetenciesSuccess(competencies));
        }).catch(error => {
            dispatch(getSupplierCompetenciesError());

            if (!error instanceof ResourceException) {
                throw error;
            }
        });
    }
}

export function getSelectedCompetencies() {
    return (dispatch, getState) => {

        return PrivateAPIResource.all(`companies/${getState().user.company.id}/supplier-competencies`)
            .then(competencies => {
                dispatch(getSelectedCompetenciesSuccess(competencies));
            })
            .catch(error => {
                dispatch(getSupplierCompetenciesError());

                if (!error instanceof ResourceException) {
                    throw error;
                }
            });
    }
}

export function applySupplierCompetencies() {
    return (dispatch, getState) => {
        const competencyIds = getState().supplierCompetencies.selected.join(',') || 0;

        const resource =`companies/${getState().user.company.id}/supplier-competencies/${competencyIds}`;

        return PrivateAPIResource.put(resource).catch(error => {

            if (!error instanceof ResourceException) {
                throw error;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/supplierCompetenciesActions.js